(function($) {
    'use strict';
    jQuery(document).ready(function($) {
        var $maxwidth = 880;
        var $li_width = 220;
        var width_li = 33.33;
        var width_li_be = 250;
        $("#mega_main_menu_first  ul.site-nav li.menu-level-1").each(function(index, el) {
            var $check = $(this).children('ul').children('li').hasClass('has_child');
            if ($check) {
                var $length = $(this).children('ul').children('li').length;
                var $width = parseInt($length) * $li_width;
                if ($width > $maxwidth) {
                    $width = $maxwidth;
                }
                $(this).children('ul').css('width', $width + 'px');
                $(this).children('ul').children('li').css('width', width_li + '%');
            } else {
                // $(this).children('ul').css('width', 250 + 'px');
                $(this).children("ul.mega_dropdown").addClass('no-lever-3');
                $(this).children('ul').children('li').css('width', width_li_be + 'px');
            }
        });

        $("#menu-navigation-vertical  ul.site-nav li.menu-level-1").each(function(index, el) {
            var $check = $(this).children('ul').children('li').hasClass('has_child');
            if ($check) {
                var $length = $(this).children('ul').children('li').length;
                var $width = parseInt($length) * $li_width;
                if ($width > $maxwidth) {
                    $width = $maxwidth;
                }
                $(this).children('ul').css('width', $width + 'px');
            } else {
                $(this).children("ul.mega_dropdown").addClass('no-lever-3');
            }
        });
        var offset = 220; // Kéo xuống khoảng cách 220px thì xuất hiện button
        var duration = 500; // THời gian di trượt là 0.5 giây
        jQuery(window).scroll(function() {
            if (jQuery(this).scrollTop() > offset) {
                $(".enable-fixed").addClass('menu-fixed');
            } else {
                $(".enable-fixed").removeClass('menu-fixed');
            }
        });
        $(".wishlist").on('click', function(event) {
            var $this = $(this);
            event.preventDefault();
            /* Act on the event */
            var myid = $(this).data('form');
            var args = $("input[value='" + myid + "']").first().parent('form').serialize();
            $("#loading").show();
            $.ajax({
                url: '/contact',
                type: 'POST',
                dataType: 'html',
                data: args,
                success: function(data, status) {
                    if (status == "success") {
                        $this.hide(600).next('a.added-wishlist').show(700);
                        $("#loading").hide(500);
                        swal("Success!", "Added success to wishlist!", "success");
                    } else {
                        $("#loading").hide(500);
                        sweetAlert("Oops...", "Please login to use wishlist!", "error");
                    }
                }
            });
        });
        $(".wishlist-login").on('click', function(event) {
            event.preventDefault();
            /* Act on the event */
            sweetAlert("Oops...", "Please login to use wishlist!", "error");
        });
        $(".wishlist-addtocart").on('click', function(event) {
            event.preventDefault();
            /* Add product in wishlist to cart*/
            var $this = $(this);
            $("#loading").show();
            var value = $(this).data('wid');
            $('.product-select').val(value);
            var args = $('.add-variant').serialize();
            $.ajax({
                url: $('.add-variant').attr('action'),
                type: 'POST',
                dataType: 'html',
                data: args,
                success: function(data, status) {
                    if (status == "success") {
                        $this.hide(600).next('button.wishlist-addedtocart').removeClass('wishlist-addedtocart').show(700);
                        $("#loading").hide(500);
                        swal("Success!", "Added success to cart!", "success");
                    } else {
                        $("#loading").hide(500);
                        sweetAlert("Oops...", "An error occurred when add to cart!", "error");
                    }
                }
            });
        });
        $('.wishlist-remove').on('click', function(event) {
            event.preventDefault();
            $("#loading").show();
            /* Remove product from wishlist*/
            var $this = $(this);
            var value = $(this).data('wid');
            $('.remove-value').val(value);
            var args = $('.contact-form').serialize();
            $.ajax({
                url: $('.contact-form').attr('action'),
                type: 'POST',
                dataType: 'html',
                data: args,
                success: function(data, status) {
                    if (status == "success") {
                        $("tr." + value).slideUp(600);
                        $("#loading").hide(500);
                        swal({
                            title: "Auto close alert!",
                            text: "Remove success.",
                            timer: 2000,
                            showConfirmButton: false
                        });
                    } else {
                        $("#loading").hide(500);
                    }
                }
            });
        });
        /* Compare Product**/
        var storage = $.localStorage;
        var compare = {};
        var total_compare = 3;
        if (storage.isSet('compare')) {
            compare = storage.get('compare');
        } else {
            storage.set('compare', {});
        }
        $(".compare").on('click', function(event) {
            event.preventDefault();
            /* Act on the event */
            var $this = $(this);
            var pid = $(this).data('pid');

            compare = storage.get('compare');
            if ($.isEmptyObject(compare)) {
                compare = {};
            }
            var check_compare = true;
            if (Object.keys(compare).length >= total_compare) {
                swal({
                    title: "info",
                    text: "Product Added over 3 product !. Do you want go to compare page ?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#4cae4c",
                    confirmButtonText: "Yes,I want view it!",
                    timer: 5000,
                    cancelButtonText: "Continue",
                    closeOnConfirm: false
                },
                function() {
                    window.location.href = 'https://' + Shopify.shop + '/pages/compare'
                });
            } else {
                for (var i = 1; i <= 3; i++) {
                    if (compare['p' + i] == "" || compare['p' + i] == undefined) {
                        compare['p' + i] = pid;
                        break;
                    } else if (compare['p' + i] == pid) {
                        $this.addClass('added');
                        check_compare = false;
                        swal( {
                            title: "info",
                            text: "Product added to compare!. Do you want go to compare page ?",
                            type: "Noitice",
                            showCancelButton: true,
                            confirmButtonColor: "#4cae4c",
                            confirmButtonText: "Yes,I want view it!",
                            timer: 5000,
                            cancelButtonText: "Continue",
                            closeOnConfirm: false},
                            function() {
                                window.location.href = 'https://' + Shopify.shop + '/pages/compare'
                            });

                            break;
                        }
                    }
                }
                if (check_compare) {
                    storage.set('compare', compare);
                    // swal("Success!", "Added success to compare!", "success");
                    swal({
                        title: "Success",
                        text: "Added success to compare!. Do you want go to compare page ?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#4cae4c",
                        timer: 5000,
                        cancelButtonText: "Continue",
                        confirmButtonText: "Yes,I want view it!",
                        closeOnConfirm: false
                    },
                    function() {
                        window.location.href = 'https://' + Shopify.shop + '/pages/compare'
                    });
                    $this.addClass('add-success');
                }
            });



        $(".quick-view").on('click', function(event) {
            event.preventDefault();
            /* Act on the event */
            $("#loading").show(400);
            var url = $(this).attr('href');
            $("#quick-view-modal .modal-content").load(url + " #product-single", function() {
                $("#quick-view-modal").modal('show');
                setTimeout(function() {
                    bx_slider = $('.bxslider').bxSlider({
                        pagerCustom: '#bx-pager',
                        controls:false,
                        onSlideBefore: function($slideElement, oldIndex, newIndex) {},
                        onSlideAfter: function($slideElement, oldIndex, newIndex) {
                            $('.zoomContainer').remove();
                            $.removeData($(".bxslider li img"), 'elevateZoom');
                            $(".bxslider li:nth-of-type(" + (newIndex + 2) + ") img").elevateZoom(zoom_config);
                        }
                    });
                    bx_page = $("#ProductThumbs").bxSlider({
                        slideWidth: 84,
                        slideMargin: 12,
                        minSlides: 4,
                        maxSlides: 4,
                        pager: false,
                        speed: 500,
                        pause: 3000
                    });
                    $(".bxslider li:nth-of-type(2) img").elevateZoom(zoom_config);
                    $("#loading").hide(600);
                }, 200);
            });
        });
        /**
        * End quickview
        */

        $(".add-to-cart").on('click', function(event) {
            event.preventDefault();
            $.ajax({
                url: '/cart/add.js',
                type: 'POST',
                dataType: 'json',
                data: {
                    quantity: 1,
                    id: $(this).data('pid')
                },
                success: function(response) {
                    console.log(response);
                    swal({
                        title: "Info",
                        text: "Added success product to your cart!",
                        imageUrl: "//cdn.shopify.com/s/files/1/1172/2346/t/2/assets/cart.png?v=144559371398844728631455676612",
                        showCancelButton: true,
                        confirmButtonColor: "#4cae4c",
                        confirmButtonText: "View cart !",
                        cancelButtonText: "Continue",
                        closeOnConfirm: true
                    },
                    function() {
                        show_cart();
                    });
                }
            });
        });
        /** Function display list all product in cart */
        function show_cart() {
            $.ajax({
                url: ' /cart.js',
                type: 'GET',
                dataType: 'json',
                success: function(data) {
                    if (data.item_count > 0) {
                        var html = '';
                        $.each(data.items, function(index, el) {
                            html = html + '<li> <h3 class="cart-title"> ' + el.title + '  </h3><div class="cart-image">';
                            html = html + ' <img src="' + el.image + '" width="50" /> </div> ';
                            html = html + ' <p> Price <strong> ' + el.price + ' </strong> </p>';
                            html = html + ' <p> Quantity <strong> ' + el.quantity + ' </strong> </p>';
                        });

                        $("#quick-view-modal").modal('show');

                        $("#quick-view-modal .modal-content").html(html);
                        // swal({   title: "Your cart <i class=\"fa fa-opencart\"></i>",   text: html,   html: true,imageUrl: "//cdn.shopify.com/s/files/1/1172/2346/t/2/assets/cart.png?v=144559371398844728631455676612" });
                    } else {
                        sweetAlert("Oops...", "Cart is empty!", "error");
                    }
                }
            });
        }

        /**
        *
        * Countdown time
        */
        $(".timmer-event").each(function() {
            var event_time = $(this).data('datetime');
            $(this).countdown(event_time, function(event) {
                var $this = $(this).html(event.strftime('' + '<span class="weeks">%w</span> weeks ' + '<span class="days">%d</span> days ' + '<span class="hours">%H</span> hr ' + '<span class="mins">%M</span> min ' + '<span class="secs">%S</span> sec'));
            });
        });

        $('[data-toggle=\'tooltip\']').tooltip({
            container: 'body'
        });
        $(".rdcma-carousel-product").each(function(index,val){
            var col = $(this).data('items');
            var single_item =false ;
            if( col ==1 ){
                single_item = true;
            }
        });

    });
})(jQuery);
